import { Component, Fragment } from 'react'
import Slider from 'react-slick'
import API from '../../api'
import { FormattedMessage } from 'react-intl'
import PriceConverter from '../helpers/PriceConverter'
import DateFormat from '../helpers/DateFormat'
import {
  setOperatorIconClass,
  getOperatorTypeTitle,
} from '../popups/GroupBookingPopup'

const settings = {
  slidesToShow: 3,
  slidesToScroll: 3,
  infinite: false,
  dots: true,
  responsive: [
    { breakpoint: 1025, settings: { slidesToShow: 3, slidesToScroll: 3 } },
    {
      breakpoint: 769,
      settings: { slidesToShow: 2.5, slidesToScroll: 1, arrows: false },
    },
    {
      breakpoint: 481,
      settings: { slidesToShow: 1.2, slidesToScroll: 1, arrows: false },
    },
  ],
}
export default class OtherGroupTrips extends Component {
  constructor(props) {
    super(props)

    this.state = {
      trips: [],
    }
  }

  componentDidMount() {
    this.getTrips()
  }

  getTrips = () => {
    API(`marketplace/${this.props.slug}/other-group-trips/`)
      .get()
      .then((trips) => {
        if(trips.length === 0) {
          document.getElementById('other-trips').hidden = true
        }
        this.setState({
          trips,
        })
      })
      .catch(() => {
        document.getElementById('other-trips').hidden = true
      })
  }

  render() {
    if(!this.state.trips.length) {
      return (
        <FormattedMessage
          id='there_is_no_items'
          defaultMessage='There is no items'
        />
      )
    }

    return (
      <Slider className='slick-pt-custom same-height' {...settings}>
        {this.state.trips.map((trip) => {
          return (
            <div
              className='element bordered-element'
              onClick={() => {
                window.location.href = trip.url
              }}
              key={trip.id}
            >
              <div className='img-wrapper'>
                <span
                  style={{ backgroundImage: `url(${trip.background})` }}
                  className='img'
                />
              </div>

              <div className='info'>
                <strong className='shop-title'>
                  {trip.country} -{' '}
                  <DateFormat date={trip.dateStart} format='MMMM YYYY' />
                </strong>
                <p className='trip-title'>{trip.title}</p>
                <ul className='features'>
                  <li>
                    <i
                      className={`font-icons ${setOperatorIconClass(
                        trip.operatorType
                      )}`}
                    />
                    {getOperatorTypeTitle(trip.operatorType)}
                  </li>
                  <li>
                    <i className='font-icons calendar-icon' />
                    <span>
                      <DateFormat
                        date={trip.dateStart}
                        format={
                          trip.dateStart.substr(0, 4) ===
                          trip.dateEnd.substr(0, 4)
                            ? 'DD MMM'
                            : 'DD MMM YYYY'
                        }
                      />{' '}
                      - <DateFormat date={trip.dateEnd} format='DD MMM YYYY' />,
                      &nbsp;
                      <FormattedMessage
                        id='night_trip_qty'
                        values={{ qty: trip.nights }}
                        defaultMessage='{qty, plural, one {# night} other {# nights}}'
                      />
                    </span>
                  </li>
                  {/* { (trip.groupSizeMax || trip.groupSizeMin) && (
                      <li>
                        <i className='font-icons peoples-icon' />
                        { trip.groupSizeMax === trip.groupSizeMin ? (
                          <FormattedMessage id='people_group_same'
                            values={{
                              max: trip.groupSizeMax || trip.groupSizeMin,
                            }}
                            defaultMessage='{max} people group' />
                        ) : (
                          <FormattedMessage id='people_group'
                            values={{
                              min: trip.groupSizeMin,
                              max: trip.groupSizeMax,
                            }}
                            defaultMessage='{min} - {max} people group' />
                        ) }
                      </li>
                    ) } */}
                </ul>
                <div className='price-wrap'>
                  {trip.itemsLeft === 0 && (
                    <div className='sold-out'>
                      <i className='font-icons fail-icon-new' />{' '}
                      <FormattedMessage
                        id='sold-out'
                        defaultMessage='Sold out'
                      />
                    </div>
                  )}
                  {trip.itemsLeft !== 0 && (
                    <Fragment>
                      {trip.itemsLeft && trip.itemsLeft <= 4 && (
                        <div className='spots-number'>
                          <FormattedMessage
                            id='spots-left'
                            values={{ qty: trip.itemsLeft }}
                            defaultMessage='Only {qty, plural, one {# item} other {# items}} left'
                          />
                        </div>
                      )}
                      <p className='price-from mbn'>
                        <FormattedMessage id='price_from' defaultMessage='from' />
                      </p>
                      <span className='price'>
                        <PriceConverter
                          amount={trip.price}
                          currency={trip.currency}
                        />
                      </span>
                      <div className='price-type'>
                        <FormattedMessage
                          id='per_person'
                          defaultMessage='per person'
                        />
                      </div>
                    </Fragment>
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </Slider>
    )
  }
}
